import { Stack, Accordion, AccordionSummary, AccordionDetails, Typography, Chip } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import dayjs from "dayjs";
import { useQuestionnaireContext } from "../../../../contexts/QuestionnaireContext";
import { ProblemasAccordion } from "./ProblemasAccordion";
import { GenericTimeline } from "../GenericTimeline";
import { useState } from "react";

const style: any = {
  Melhora: "#007C6D",
  Concluído: "#007C6D",
  Estável: "#FBBB3C",
  Parcialmente: "#FBBB3C",
  Piora: "#EF4352",
  Falhou: "#EF4352",
};

export function ProblemasHistory() {
  const { historyValues } = useQuestionnaireContext();

  const responseEntries = historyValues?.map((el: any) => el?.resource);

  const problemasReponses = responseEntries?.map((el: any) => {
    const awnserDate = el?.authored;
    const filterItens = el?.item
      ?.filter((e: any) => e?.text === "Lista de Problemas")?.[0]
      ?.item?.filter((subItem: any) => {
        const verifyDuplicates = el?.item
          ?.filter((e: any) => e?.text === "Condutas")?.[0]
          ?.item?.some((e: any) => {
            return (
              e?.item[0].answer[0].valueString === subItem?.item?.[0]?.answer &&
              e.item?.[1]?.answer?.[0]?.valueCoding
            );
          });
        return (
          subItem?.item?.[1]?.answer?.[0]?.valueCoding &&
          subItem?.item?.[0]?.answer &&
          !verifyDuplicates
        );
      });
    const displayReferences = el?.item?.filter(
      (e: any) => e?.linkId === "displayReferences"
    )?.[0]?.item;
    const displayInfo = {
      healthcare: displayReferences?.[0]?.answer?.[0]?.valueString || "",
      practitioner: displayReferences?.[1]?.answer?.[0].valueString || "",
    };
    return { awnserDate, filterItens, displayInfo };
  });

  const verifyResponse = problemasReponses?.filter(
    (el: any) => el.filterItens?.length
  );

  // Agrupa respostas por dia
  const groupedByDay = verifyResponse?.reduce((acc: any, item: any) => {
    const day = dayjs(item.awnserDate).format("DD/MM/YYYY");
    if (!acc[day]) {
      acc[day] = {
        day,
        awnserDate: item.awnserDate,
        items: [],
      };
    }
    acc[day].items.push(item);
    return acc;
  }, {}) || {};

  // Converte para array para usar na timeline
  const timelineData = Object.values(groupedByDay);

  return (
    <Stack spacing={1}>
      <GenericTimeline
        data={timelineData}
        dotColor={style}
        component={(data: any, index: number) => (
          <DayAccordion 
            day={data.day} 
            items={data.items} 
            style={style} 
            defaultExpanded={index === 0} 
          />
        )}
      />
    </Stack>
  );
}

// Componente Accordion que agrupa problemas por dia
function DayAccordion({ day, items, style, defaultExpanded }: any) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  // Conta o total de problemas dentro de todos os questionários do dia
  const totalProblemas = items.reduce((total: number, item: any) => {
    return total + (item?.filterItens?.length || 0);
  }, 0);

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      sx={{
        width: "100%",
        boxShadow: "1px 1px 16px 1px rgba(0, 0, 0, 0.1)",
        border: "1px solid",
        borderColor: "neutral200.main",
        borderRadius: 1,
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Stack direction="row" alignItems="center" spacing={2} width="100%">
          <Chip 
            label={`${totalProblemas} ${totalProblemas === 1 ? 'problema' : 'problemas'}`}
            size="small"
            sx={{ fontWeight: 500 }}
          />
        </Stack>
      </AccordionSummary>
      
      <AccordionDetails>
        <Stack spacing={1}>
          {items.map((data: any, idx: number) => (
            <ProblemasAccordion key={idx} style={style} data={data} index={idx} />
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
